import React from "react";
import { createPortal } from "react-dom";
import "./mobile-modal.css";
// Importing defaultIcons from the desktop component location
import { defaultIcons } from "../../info-modal/icons";

const MobileModal = ({
    isOpen,
    onClose,
    title,
    description,
    icon,
    iconType,
    actions = [],
    children
}) => {
    if (!isOpen) return null;

    return createPortal(
        <div className="mobile-modal-overlay" onClick={onClose}>
            <div
                className="mobile-modal-container"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="mobile-modal-icon">
                    {iconType && defaultIcons[iconType] ? defaultIcons[iconType] : (icon && <img src={icon} alt="icon" />)}
                </div>

                {title && <h2 className="mobile-modal-title">{title}</h2>}

                {description && (
                    <div className="mobile-modal-description">
                        {typeof description === 'string' ? (
                            <span dangerouslySetInnerHTML={{ __html: description }} />
                        ) : (
                            description
                        )}
                    </div>
                )}

                {children}

                <div className="mobile-modal-actions">
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            onClick={action.onClick}
                            className={
                                action.variant === 'primary' ? "mobile-modal-btn-primary" :
                                    action.variant === 'secondary' ? "mobile-modal-btn-secondary" :
                                        (index === 0 ? "mobile-modal-btn-primary" : "mobile-modal-btn-secondary")
                            }
                        >
                            {action.text}
                        </button>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default MobileModal;
